
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/synthese-et-medias/data-center-front/sentry.client.config.ts")
            }
          });